import React, { createContext } from 'react';

const AlmasightsContext = createContext();

export default AlmasightsContext;
